import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  DELETE_ANALYTE,
  DELETE_INSTRUMENT_TYPE,
  GET_INSTRUMENT_TYPE_LIST,
  ADD_NEW_INSTRUMENT_TYPE,
  UPDATE_NEW_INSTRUMENT_TYPE,
  GET_ANALYTE_LIST,
  GET_ANALYTEFORSCHEME_LIST,
  ADD_NEW_ANALYTE_LIST,
  UPDATE_NEW_ANALYTE_LIST,
  GET_SCHEMEANALYTE_LIST,
  ADD_NEW_SCHEMEANALYTE,
  UPDATE_SCHEMEANALYTE,
  GET_ANALYTESCYCLES,
  GET_SAMPLE_ANALYTE_LIST,
  ADD_NEW_SAMPLE_ANALYTE,
  UPDATE_SAMPLE_ANALYTE,
  ADD_EQUIPMENTTYPE_FILE,
  GET_ANALYTESSAMPLE,
  GET_INSTRUMENT_ANALYTE_LIST,
  ADD_NEW_INSTRUMENT_ANALYTE,
  UPDATE_INSTRUMENT_ANALYTE,
  GET_INSTRUMENT_DETAIL,
  GET_REAGENT_ANALYTE_LIST,
  ADD_NEW_REAGENT_ANALYTE,
  UPDATE_REAGENT_ANALYTE,
  GET_METHOD_ANALYTE_LIST,
  ADD_NEW_METHOD_ANALYTE,
  UPDATE_METHOD_ANALYTE,
  GET_MICROBIOLOGY_DATA,
  ADD_MICROBIOLOGY_DATA,
  GET_INSTRUMENT_REPORT,
  GET_ANALYTE_REPORT1,
  GET_SAMPLE_REPORT,
  POST_SAMPLE_REPORT,
  UPDATE_SAMPLE_REPORT,
  GET_INSTRUMENT_REPORT_LAB,
  UPDATE_ROUND_INSTRUMENT,
} from "./actionTypes";

import {
  deleteAnalyteSuccess,
  deleteAnalyteFail,
  getinstrumenttypelistSuccess,
  getinstrumenttypelistFail,
  addNewInstrumentTypeSuccess,
  addNewInstrumentTypeFail,
  updateNewInstrumentTypeSuccess,
  updateNewInstrumentTypeFail,
  addNewAnalyteListFail,
  addNewAnalyteListSuccess,
  updateAnalyteListSuccess,
  updateAnalyteListFail,
  getAnalytelistFail,
  getAnalyteforSchemelistSuccess,
  getAnalyteforSchemelistFail,
  getAnalytelistSuccess,
  deleteInstrumentTypeSuccess,
  deleteInstrumentTypeFail,
  getSchemeAnalytelistSuccess,
  getSchemeAnalytelistFail,
  addNewSchemeAnalytelistSuccess,
  addNewSchemeAnalytelistFail,
  updateSchemeAnalytelistSuccess,
  updateSchemeAnalytelistFail,
  getAnalyteCycleFail,
  getAnalyteCycleSuccess,
  getSampleAnalytelistSuccess,
  getSampleAnalytelistFail,
  addNewSampleAnalytelistSuccess,
  addNewSampleAnalytelistFail,
  updateSampleAnalytelistSuccess,
  updateSampleAnalytelistFail,
  addEquipmentTypefileFail,
  getAnalyteSampleFail,
  getAnalyteSampleSuccess,
  getInstrumentDetailSuccess,
  getInstrumentDetailFail,
  addNewInstrumentAnalytelistSuccess,
  addNewInstrumentAnalytelistFail,
  getInstrumentAnalytelistFail,
  updateInstrumentAnalytelistSuccess,
  updateInstrumentAnalytelistFail,
  getInstrumentAnalytelistSuccess,
  getReagentAnalytelistSuccess,
  getReagentAnalytelistFail,
  addNewReagentAnalytelistSuccess,
  addNewReagentAnalytelistFail,
  updateReagentAnalytelistFail,
  updateReagentAnalytelistSuccess,
  getMethodAnalytelistSuccess,
  getMethodAnalytelistFail,
  addNewMethodAnalytelistSuccess,
  addNewMethodAnalytelistFail,
  updateMethodAnalytelistSuccess,
  updateMethodAnalytelistFail,
  getMicroDataSuccess,
  getMicroDataFail,
  addMicroDataSuccess,
  addMicroDataFail,
  getInstrumentReportSuccess,
  getInstrumentReportFail,
  getanalytereport1Success,
  getanalytereport1Fail,
  sampleReportSuccess,
  sampleReportFail,
  postSampleReportSuccess,
  postSampleReportFail,
  updateSampleReportSuccess,
  updateSampleReportFail,
  getInstrumentReportLabSuccess,
  getInstrumentReportLabFail,
  updateRoundInstrumentSuccess,
  updateRoundInstrumentFail,
} from "./actions";

//Include Both Helper File with needed methods
import {
  deleteAnalyte,
  deleteInstrumentType,
  getInstrumenttypelist,
  addNewInstrumentType,
  updateNewInstrumentType,
  getAnalytelist,
  updateAnalyte,
  addNewAnalyte,
  getSchemeAnalytelist,
  getAnalyteforSchemelist,
  addNewSchemeAnalytelist,
  updateSchemeAnalytelist,
  getAnalyteCycle,
  addEquipmentTypefile,
  getSampleAnalytelist,
  addNewSampleAnalytelist,
  updateSampleAnalytelist,
  getAnalyteSampleList,
  getInstrumentAnalytelist,
  addNewInstrumentAnalytelist,
  updateInstrumentAnalytelist,
  getInstrumentDetail,
  getReagentAnalytelist,
  addNewReagentAnalytelist,
  updateReagentAnalytelist,
  getMethodAnalytelist,
  addNewMethodAnalytelist,
  updateMethodAnalytelist,
  getMicroData,
  addMicrobiologyData,
  getInstrumentReportAPI,
  apiGetAnalyteReport1,
  apiSampleReport,
  apipostSampleReport,
  apiupdateSampleReport,
  getInstrumentReportLabAPI,
  postUpdateRoundInstrument,
} from "../../helpers/django_api_helper";

// ADD EQUIPMENT TYPE FILE

// Sample Analyte
function* fetchSampleAnalyteList(object) {
  try {
    // Call the API and get the response
    const response = yield call(getSampleAnalytelist, object.payload);

    // Extract `sample_name` and `analytes` from the API response
    const { sample_name, analytes } = response.data;

    console.log("Saga - API Response:", response.data); // Debugging log
    console.log("Saga - Extracted Sample Name:", sample_name);
    console.log("Saga - Extracted Analytes:", analytes);

    // Dispatch success action with structured payload
    yield put(
      getSampleAnalytelistSuccess({
        sampleName: sample_name || "Unknown Sample", // Default if missing
        analytes: analytes || [], // Default to empty array if missing
      }),
    );
  } catch (error) {
    console.error("Saga - Error in fetchSampleAnalyteList:", error);
    yield put(getSampleAnalytelistFail(error));
  }
}

function* onAddNewSampleAnalyte(object) {
  try {
    const response = yield call(
      addNewSampleAnalytelist,
      object.payload.createSampleAnalyte,
      object.payload.id,
    );
    yield put(addNewSampleAnalytelistSuccess(response));
  } catch (error) {
    yield put(addNewSampleAnalytelistFail(error));
  }
}
function* onUpdateSampleAnalyte({ payload: schemeanalyte }) {
  try {
    const response = yield call(updateSampleAnalytelist, schemeanalyte);
    yield put(updateSampleAnalytelistSuccess(response));
  } catch (error) {
    yield put(updateSampleAnalytelistFail(error));
  }
}
//////////////////////////////////////
function* fetchInstrumentAnalyteList(object) {
  try {
    console.log("Saga - Payload for API Call:", object.payload);

    const response = yield call(getInstrumentAnalytelist, object.payload);
    console.log("Saga - API Response:", response);

    // ✅ Extract all required fields from the response
    const analytes = response?.instrument_analytes || [];
    const instrumentName = response?.instrument_name || "Unknown Instrument";
    const activeSchemes = response?.active_schemes || [];

    const transformedResponse = {
      analytes,
      instrument_name: instrumentName,
      active_schemes: activeSchemes, // ✅ Use this key to match reducer
    };

    console.log("Saga - Transformed Response:", transformedResponse);

    // Dispatch success action
    yield put(getInstrumentAnalytelistSuccess(transformedResponse));
  } catch (error) {
    console.error(
      "Saga - Error Fetching Instrument Analytes:",
      error.message,
      error.stack,
    );
    yield put(getInstrumentAnalytelistFail(error));
  }
}

function* onAddNewInstrumentAnalyte(object) {
  try {
    const response = yield call(
      addNewInstrumentAnalytelist,
      object.payload.addInstrumentAnalyte,
      object.payload.id,
    );
    yield put(addNewInstrumentAnalytelistSuccess(response));
  } catch (error) {
    yield put(addNewInstrumentAnalytelistFail(error));
  }
}
function* onUpdateInstrumentAnalyte({ payload: schemeanalyte }) {
  try {
    const response = yield call(updateInstrumentAnalytelist, schemeanalyte);
    yield put(updateInstrumentAnalytelistSuccess(response));
  } catch (error) {
    yield put(updateInstrumentAnalytelistFail(error));
  }
}

function* onAddEquipmentTypefile(object) {
  console.log("saga responce", object);

  try {
    const response = yield call(
      addEquipmentTypefile,
      object.payload.EquipmentData,
      object.payload.id,
    );
    yield put(addEquipmentTypefileSuccess(response));
  } catch (error) {
    yield put(addEquipmentTypefileFail(error));
  }
}
/// Scheme Analytes
function* fetchSchemeAnalyteList(object) {
  try {
    console.log(
      "Saga - Fetching Scheme Analyte List with Payload:",
      object.payload,
    );

    // Call the API
    const response = yield call(getSchemeAnalytelist, object.payload);
    console.log("Saga - API Response:", response.data); // Log the full API response

    // Extract analytes
    const analytes = response.data.analytes || [];
    console.log("Saga - Extracted Analytes:", analytes); // Log the extracted analytes

    // Extract scheme name as a string
    const SchemeName = response.data.scheme_name || "Unknown";
    console.log("Saga - Extracted Scheme Name:", SchemeName); // Log the extracted scheme name

    // Dispatch success with both analytes and scheme name
    yield put(
      getSchemeAnalytelistSuccess({
        analytes,
        SchemeName, // Pass scheme name as a string
      }),
    );
  } catch (error) {
    console.error("Saga - Error Fetching Scheme Analyte List:", error); // Log any errors
    yield put(getSchemeAnalytelistFail(error));
  }
}

function* onAddNewSchemeAnalyte(object) {
  try {
    const response = yield call(
      addNewSchemeAnalytelist,
      object.payload.createSchemeAnalyte,
      object.payload.id,
    );
    yield put(addNewSchemeAnalytelistSuccess(response));
  } catch (error) {
    yield put(addNewSchemeAnalytelistFail(error));
  }
}

function* onUpdateSchemeAnalyte({ payload: schemeanalyte }) {
  try {
    const response = yield call(updateSchemeAnalytelist, schemeanalyte);
    yield put(updateSchemeAnalytelistSuccess(response));
  } catch (error) {
    yield put(updateSchemeAnalytelistFail(error));
  }
}

/////// Analytes Associated Aith Cycle
function* fetchAnalyteCycles(object) {
  try {
    const response = yield call(getAnalyteCycle, object.payload);
    console.log("API Response for Analyte Cycles:", response.data);

    const analytes = response.data.analytes || [];
    const CycleName = response.data.cycle_name || "Unknown"; // Default to "Unknown" if missing

    yield put(getAnalyteCycleSuccess({ analytes, CycleName }));
  } catch (error) {
    console.error("Error in fetchAnalyteCycles:", error);
    yield put(getAnalyteCycleFail(error));
  }
}

// InstrumentType
function* fetchInstrumentTypeList(object) {
  try {
    const response = yield call(getInstrumenttypelist, object.payload);
    console.log("Response from getinstrumenttypelist:", response); // Log the response object
    yield put(getinstrumenttypelistSuccess(response.data));
  } catch (error) {
    yield put(getinstrumenttypelistFail(error));
  }
}
function* onAddNewInstrumentType(object) {
  try {
    const response = yield call(
      addNewInstrumentType,
      object.payload.createUnit,
      object.payload.id,
    );
    yield put(addNewInstrumentTypeSuccess(response));
  } catch (error) {
    yield put(addNewInstrumentTypeFail(error));
  }
}
function* onUpdateInstrumentType({ payload: unit }) {
  try {
    const response = yield call(updateNewInstrumentType, unit);
    yield put(updateNewInstrumentTypeSuccess(response));
  } catch (error) {
    yield put(updateNewInstrumentTypeFail(error));
  }
}

function* onDeleteInstrumentType({ payload: InstrumentType }) {
  try {
    const response = yield call(deleteInstrumentType, InstrumentType);
    yield put(deleteInstrumentTypeSuccess(response));
  } catch (error) {
    yield put(deleteInstrumentTypeFail(error));
  }
}

function* fetchAnalyteList(object) {
  try {
    const response = yield call(getAnalytelist, object.payload);
    console.log("Response from getAnalytelist:", response); // Log the response object
    yield put(getAnalytelistSuccess(response.data));
  } catch (error) {
    yield put(getAnalytelistFail(error));
  }
}
function* fetchAnalyteforSchemeList(object) {
  try {
    console.log("Fetching Analytes for Scheme with Payload:", object.payload);

    const response = yield call(getAnalyteforSchemelist, object.payload);
    console.log("Response from getAnalyteforSchemelist:", response.data);

    const analytes = response.data.analytes || [];
    const SchemeName = response.data.scheme_name || "Unknown";

    yield put(
      getAnalyteforSchemelistSuccess({
        analytes,
        SchemeName, // Include scheme name in the success payload
      }),
    );
  } catch (error) {
    console.error("Error in fetchAnalyteforSchemeList:", error);
    yield put(getAnalyteforSchemelistFail(error));
  }
}

function* onAddNewAnalyte(object) {
  try {
    const response = yield call(
      addNewAnalyte,
      object.payload.createUnit,
      object.payload.id,
    );
    yield put(addNewAnalyteListSuccess(response));
  } catch (error) {
    yield put(addNewAnalyteListFail(error));
  }
}
function* onUpdateAnalyte({ payload: unit }) {
  try {
    const response = yield call(updateAnalyte, unit);
    yield put(updateAnalyteListSuccess(response));
  } catch (error) {
    yield put(updateAnalyteListFail(error));
  }
}

function* onDeleteAnalyte({ payload: Analyte }) {
  try {
    const response = yield call(deleteAnalyte, Analyte);
    yield put(deleteAnalyteSuccess(response));
  } catch (error) {
    yield put(deleteAnalyteFail(error));
  }
}

function* fetchAnalyteSample(object) {
  try {
    // Call the API and fetch the response
    const response = yield call(getAnalyteSampleList, object.payload);

    // Extract `sample_name` and other relevant data from the API response
    const sampleName = response.data.sample_name || "Unknown Sample"; // Default to "Unknown Sample" if missing
    const analytes = response.data.analytes || []; // Assuming the response contains analytes

    console.log("Saga - API Response:", response.data); // Debugging log
    console.log("Saga - Extracted Sample Name:", sampleName);

    // Dispatch success action with extracted data
    yield put(
      getAnalyteSampleSuccess({
        analytes,
        sampleName,
      }),
    );
  } catch (error) {
    console.error("Saga - Error in fetchAnalyteSample:", error);
    yield put(getAnalyteSampleFail(error));
  }
}

function* fetchInstrumentDetail(object) {
  try {
    const response = yield call(getInstrumentDetail, object.payload);
    yield put(getInstrumentDetailSuccess(response.data));
  } catch (error) {
    yield put(getInstrumentDetailFail(error));
  }
}

function* fetchReagentAnalyteList(object) {
  try {
    console.log("Saga - Payload for Reagent API Call:", object.payload);

    const response = yield call(getReagentAnalytelist, object.payload);
    console.log("Saga - API Response for Reagent:", response);

    // ✅ Extract and transform data
    const analytes = response?.reagent_analytes || [];
    const reagentName = response?.reagent_name || "Unknown Reagent";
    const activeSchemes = response?.active_schemes || [];

    const transformedResponse = {
      analytes,
      reagent_name: reagentName,
      active_schemes: activeSchemes,
    };

    console.log("Saga - Transformed Reagent Response:", transformedResponse);

    yield put(getReagentAnalytelistSuccess(transformedResponse));
  } catch (error) {
    console.error(
      "Saga - Error Fetching Reagent Analytes:",
      error.message,
      error.stack,
    );
    yield put(getReagentAnalytelistFail(error));
  }
}

function* onAddNewReagentAnalyte(object) {
  try {
    const response = yield call(
      addNewReagentAnalytelist, // <- this is API call, not action
      object.payload.addReagentAnalyte,
      object.payload.id,
    );
    console.log("📤 Saga Response:", response);
    yield put(addNewReagentAnalytelistSuccess(response));
  } catch (error) {
    console.error("❌ Saga Error:", error);
    yield put(addNewReagentAnalytelistFail(error));
  }
}

function* onUpdateReagentAnalyte({ payload: schemeanalyte }) {
  try {
    const response = yield call(updateReagentAnalytelist, schemeanalyte);
    yield put(updateReagentAnalytelistSuccess(response));
  } catch (error) {
    yield put(updateReagentAnalytelistFail(error));
  }
}
///////////////
function* fetchMethodAnalyteList(object) {
  try {
    console.log("Saga - Payload for Reagent API Call:", object.payload);

    const response = yield call(getMethodAnalytelist, object.payload);
    console.log("Saga - API Response for Reagent:", response);

    // ✅ Extract and transform data
    const analytes = response?.method_analytes || [];
    const methodName = response?.method_name || "Unknown Reagent";
    const activeSchemes = response?.active_schemes || [];

    const transformedResponse = {
      analytes,
      method_name: methodName,
      active_schemes: activeSchemes,
    };

    console.log("Saga - Transformed Reagent Response:", transformedResponse);

    yield put(getMethodAnalytelistSuccess(transformedResponse));
  } catch (error) {
    console.error(
      "Saga - Error Fetching Reagent Analytes:",
      error.message,
      error.stack,
    );
    yield put(getMethodAnalytelistFail(error));
  }
}
function* onAddNewMethodAnalyte(object) {
  try {
    const response = yield call(
      addNewMethodAnalytelist, // <- this is API call, not action
      object.payload.addMethodAnalyte,
      object.payload.id,
    );
    console.log("📤 Saga Response:", response);
    yield put(addNewMethodAnalytelistSuccess(response));
  } catch (error) {
    console.error("❌ Saga Error:", error);
    yield put(addNewMethodAnalytelistFail(error));
  }
}

function* onUpdateMethodAnalyte({ payload: schemeanalyte }) {
  try {
    const response = yield call(updateMethodAnalytelist, schemeanalyte);
    yield put(updateMethodAnalytelistSuccess(response));
  } catch (error) {
    yield put(updateMethodAnalytelistFail(error));
  }
}

function* fetchMicrobiologyDataSaga({ payload }) {
  console.log("📡 Saga: Fetching microbiology data with ID:", payload);
  try {
    const response = yield call(getMicroData, payload);
    console.log("✅ Saga: Microbiology data fetched successfully:", response);

    // ✅ Use the whole response directly
    const data = response;
    console.log("📦 Extracted data for reducer:", data);

    yield put(getMicroDataSuccess(data));
  } catch (error) {
    console.error("❌ Saga: Failed to fetch microbiology data:", error);
    yield put(getMicroDataFail(error.message || "Something went wrong"));
  }
}
function* addMicrobiologyDataSaga({ payload }) {
  try {
    const response = yield call(addMicrobiologyData, payload); // ✅ sends equipment + reagent
    yield put(addMicroDataSuccess(response.data)); // .data if using axios
  } catch (error) {
    yield put(addMicroDataFail(error.message || "Add failed"));
  }
}
function* fetchInstrumentReport(action) {
  try {
    const response = yield call(getInstrumentReportAPI, action.payload);
    yield put(getInstrumentReportSuccess(response));
  } catch (error) {
    yield put(getInstrumentReportFail(error));
  }
}
function* fetchInstrumentReportLab(action) {
  try {
    const response = yield call(getInstrumentReportLabAPI, action.payload);
    yield put(getInstrumentReportLabSuccess(response));
  } catch (error) {
    yield put(getInstrumentReportLabFail(error));
  }
}
function* fetchAnalyteReport1(action) {
  try {
    const response = yield call(apiGetAnalyteReport1, action.payload);
    yield put(getanalytereport1Success(response)); // ✅ send full response (analyte + schemes)
  } catch (error) {
    yield put(getanalytereport1Fail(error));
  }
}
function* fetchSampleReport(action) {
  try {
    const response = yield call(apiSampleReport, action.payload);
    const schemes = response?.data?.schemes || [];
    yield put(sampleReportSuccess(schemes));
  } catch (error) {
    yield put(sampleReportFail(error));
  }
}
function* postSampleReport({ payload }) {
  try {
    const response = yield call(apipostSampleReport, payload);
    yield put(postSampleReportSuccess(response.data));
  } catch (error) {
    yield put(postSampleReportFail(error.message));
  }
}
function* updateSampleReport({ payload }) {
  try {
    const response = yield call(apiupdateSampleReport, payload);
    yield put(updateSampleReportSuccess(response.data));
  } catch (error) {
    yield put(updateSampleReportFail(error.message));
  }
}
function* onUpdateRoundInstrument({ payload }) {
  try {
    const response = yield call(postUpdateRoundInstrument, payload);
    yield put(updateRoundInstrumentSuccess(response));
  } catch (error) {
    yield put(
      updateRoundInstrumentFail(
        error?.response?.data?.detail || error.message || "Update failed",
      ),
    );
  }
}
function* InstrumentTypeListSaga() {
  yield takeEvery(GET_INSTRUMENT_TYPE_LIST, fetchInstrumentTypeList);
  yield takeEvery(ADD_NEW_INSTRUMENT_TYPE, onAddNewInstrumentType);
  yield takeEvery(ADD_EQUIPMENTTYPE_FILE, onAddEquipmentTypefile);
  yield takeEvery(UPDATE_NEW_INSTRUMENT_TYPE, onUpdateInstrumentType);
  yield takeEvery(DELETE_INSTRUMENT_TYPE, onDeleteInstrumentType);
  yield takeEvery(GET_ANALYTESSAMPLE, fetchAnalyteSample);
  yield takeEvery(GET_ANALYTE_LIST, fetchAnalyteList);
  yield takeEvery(GET_SAMPLE_REPORT, fetchSampleReport);
  yield takeEvery(POST_SAMPLE_REPORT, postSampleReport);
  yield takeEvery(GET_ANALYTEFORSCHEME_LIST, fetchAnalyteforSchemeList);
  yield takeEvery(UPDATE_SAMPLE_REPORT, updateSampleReport);
  yield takeEvery(ADD_NEW_ANALYTE_LIST, onAddNewAnalyte);
  yield takeEvery(UPDATE_ROUND_INSTRUMENT, onUpdateRoundInstrument);
  yield takeEvery(UPDATE_NEW_ANALYTE_LIST, onUpdateAnalyte);
  yield takeEvery(DELETE_ANALYTE, onDeleteAnalyte);
  yield takeEvery(GET_INSTRUMENT_REPORT, fetchInstrumentReport);
  yield takeEvery(GET_INSTRUMENT_REPORT_LAB, fetchInstrumentReportLab);
  yield takeEvery(GET_SCHEMEANALYTE_LIST, fetchSchemeAnalyteList);
  yield takeEvery(ADD_NEW_SCHEMEANALYTE, onAddNewSchemeAnalyte);
  yield takeEvery(UPDATE_SCHEMEANALYTE, onUpdateSchemeAnalyte);

  yield takeEvery(GET_ANALYTESCYCLES, fetchAnalyteCycles);
  yield takeEvery(GET_SAMPLE_ANALYTE_LIST, fetchSampleAnalyteList);
  yield takeEvery(ADD_NEW_SAMPLE_ANALYTE, onAddNewSampleAnalyte);
  yield takeEvery(UPDATE_SAMPLE_ANALYTE, onUpdateSampleAnalyte);

  yield takeEvery(GET_INSTRUMENT_ANALYTE_LIST, fetchInstrumentAnalyteList);
  yield takeEvery(ADD_NEW_INSTRUMENT_ANALYTE, onAddNewInstrumentAnalyte);
  yield takeEvery(UPDATE_INSTRUMENT_ANALYTE, onUpdateInstrumentAnalyte);
  yield takeEvery(GET_REAGENT_ANALYTE_LIST, fetchReagentAnalyteList);
  yield takeEvery(ADD_NEW_REAGENT_ANALYTE, onAddNewReagentAnalyte);
  yield takeEvery(UPDATE_REAGENT_ANALYTE, onUpdateReagentAnalyte);
  yield takeEvery(GET_INSTRUMENT_DETAIL, fetchInstrumentDetail);
  yield takeEvery(GET_METHOD_ANALYTE_LIST, fetchMethodAnalyteList);
  yield takeEvery(ADD_NEW_METHOD_ANALYTE, onAddNewMethodAnalyte);
  yield takeEvery(UPDATE_METHOD_ANALYTE, onUpdateMethodAnalyte);
  yield takeEvery(ADD_MICROBIOLOGY_DATA, addMicrobiologyDataSaga);
  yield takeEvery(GET_MICROBIOLOGY_DATA, fetchMicrobiologyDataSaga);
  yield takeEvery(GET_ANALYTE_REPORT1, fetchAnalyteReport1);
}

export default InstrumentTypeListSaga;
